export default {

    consent: {
        active: false,
        timeout: 3000,
    },

    detectAdBlocker: false,

    videoService: {
        baseUrl: "https://video-gateway.rtl2.de/api/"
    },

    bobyConnect: {
        baseUrl: "https://p-boby-connect-akamai.rtl2apps.de/"
    },

    vipo: {
        api: 'https://service.rtl2.de/api-player-vipo/video.php',
        vico: 'https://service.rtl2.de/api-player-vipo/playlist.php',
        reco: 'https://service.rtl2.de/api-player-vipo/playlist.php'
    },

    cmp: {
        apiVersion: "1.0",
        baseUrl: "https://p-cmp.rtl2apps.de/"
    },

    googleAnalytics: {
        active: false,
        dry: false,
        debug: false,
        trackingVersion: '3.1.3',
        property: 'UA-92628984-2'
    },

    ga4: {
        active: true,
        heartBeatSeconds: 5,
        trackingConceptVersion: '1.0.3',
        trackingProductVersion: '4.0.2',
    },

    shadowTracking: {
        active: false,
        url: 'https://www.rtl2.de/pixel/proxy',
    },

    ivw: {
        active: false,
        script: 'https://script.ioam.de/iam.js',
        iam_data: {
            "st": "rtl2", // site/domain
            "cp": "dvrsowf_ten_global_r", // code
            "co": "", // kommentar (request path)
            "sv": "ke", // FRABO Steuerung (ke/in)
            "sc": "yes" // Multistage Client & Visit Detection (MCVD)
        }
    },

    agf: {
        active: false,
        script: 'https://cdn-gl.imrworldwide.com/novms/js/2/ggcmb510.js',
        apid: 'TXXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX',// Your assigned App ID
        config: {
            // sfcode: 'eu-uat', // Environment to use should be 'eu-uat' during testing
            // prod: 'vc',
            // apn: 'RTL2Player', // Your player name
            // nol_sdkDebug:'DEBUG' //	During	testing	only,	you	can	enable	full	lo
        }
    },

    ads: true,
    breakAd: false,

    ipAds: {
        baseUrl: 'https://ad-ipd.sxp.smartclip.net/select',
        zone: 'rtl2_rtl2'
    },

    homad: {
        active: true,
        conf: {
            "enabled": true,
            "server": [
                "https://ssl.1.damoh.rtl2.de/[hash]/",
                "https://ssl.2.damoh.rtl2.de/[hash]/",
                "https://ssl.3.damoh.rtl2.de/[hash]/"
            ],
            "alias": "dertl2adipdsxpsmartclipnet",
            "config": "https://hgc-cf-cache-1.svonm.com/www.rtl2.de/config.json"
        }
    },

    holaspark: {
        active: false,
        script: '//player.h-cdn.com/loader.js?customer=rtl2_de'
    },

    jwOptions: {
        // see reference
        // @ https://developer.jwplayer.com/jw-player/docs/developer-guide/customization/configuration-reference/

        displaytitle: true,
        displaydescription: false,

        autostart: false,
        preload: 'metadata',

        width: '100%',
        height: 0,
        aspectratio: '16:9',

        debug: 'console',

        playlist: [],

        autoPause: {
            viewability: true,
            pauseAds: true
        },

        advertising: {
            controls: {
                "enable": false
            },
            client: 'vast',
            admessage: 'Werbung, gleich geht\'s weiter.',
            podmessage: ' ',
            schedule: {},
            // rules: {
            //   startOn: 1,
            //   frequency: 1,
            //   // "timeBetweenAds": 30,
            // }
        },

        plugins: null,

        logo: null,

        abouttext: 'RTL2 Player',
        aboutlink: 'http://www.rtl2.de/videos',

        nextUpDisplay: true,

        related: {
            displayMode: 'overlay', //overlay, shelf
            oncomplete: 'autoplay', // hide, show, autoplay
            autoplaymessage: 'Startet in xx', // xx & __title__
            autoplaytime: 15
        },

        localization: {
            related: 'Weitere Videos',
            nextUp: 'Nächstes Video',
            playlist: 'Playlist'
        }
    }
}



// WEBPACK FOOTER //
// ./src/settings/default.settings.js